import React, { useState, useCallback, memo } from 'react';
import { connect } from 'react-redux';
import { Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import DialogCloseButton from '../../../buttons/DialogCloseButton';
import PresetLoader from './PresetLoader';
import { createActions } from '../store';
import PresetList from './PresetList';
import { withStyles } from 'tss-react/mui';

const styles = theme => ({
    contentContainer: {
        overflowY: 'hidden',
        minHeight: 400,
        position: 'relative',
        paddingTop: "20px !important",
    }
});

const FirstPagePresetsСount = 12;

const PresetDialog = (props) => {
    const { classes, presetDialogOpen, presets, setProperty } = props;
    const [showMore, setShowMore] = useState(false);

    const onDialogClose = useCallback(() => {
        setProperty('presetDialogOpen', false);
    }, [setProperty]);

    const onShowMoreClick = useCallback(() => {
        setShowMore(true);
    }, []);

    return (
        <Dialog
            onClose={onDialogClose}
            maxWidth='lg'
            fullWidth={true}
            open={presetDialogOpen}
            scroll='body'
            aria-labelledby='preset-dialog-title'
        >
            <DialogTitle id='preset-dialog-title'>
                Select a preset for your video
                <DialogCloseButton onClick={onDialogClose} />
            </DialogTitle>
            <DialogContent className={classes.contentContainer}>
                {presets.length < 1 ? (
                    <PresetLoader />
                ) : (
                    <PresetList
                        presets={presets}
                        count={showMore ? null : FirstPagePresetsСount}
                        onShowMoreClick={onShowMoreClick}
                        classes={classes}
                    />
                )}
            </DialogContent>
            <DialogActions></DialogActions>
        </Dialog>
    );
};

const mapStateToProps = (state) => {
    const {
        presets,
        presetDialogOpen,
    } = state.create;

    return {
        presets,
        presetDialogOpen
    }
};

const mapDispatchToProps = (dispatch) => {
    const setProperty = (key, value) => dispatch(createActions.setProperty(key, value));
    return { setProperty }
};

export default connect(mapStateToProps, mapDispatchToProps)(memo(withStyles(PresetDialog, styles)));